<div class="pageheader">
  <div class="page-title">
    <h1>Partner Import</h1>
  </div>
</div>

<app-import importMode="partner"></app-import>
